import { render, staticRenderFns } from "./AddressRentList.vue?vue&type=template&id=00f4d1c4&scoped=true&"
import script from "./AddressRentList.vue?vue&type=script&lang=js&"
export * from "./AddressRentList.vue?vue&type=script&lang=js&"
import style0 from "./AddressRentList.vue?vue&type=style&index=0&id=00f4d1c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4d1c4",
  null
  
)

export default component.exports